.avatar {
  border: 2px solid transparent;

  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    var(--bc-avatar-group-border-color) border-box;
}
